import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PcmpRequestedQueuePage } from '@/features/pcmp/pages/PcmpRequestedQueuePage';
import { pcmpRequestedSearchSchema } from '@/features/pcmp/types/pcmpRequested.types';

export const Route = createFileRoute('/_auth/pcmp/requests/requested/')({
  validateSearch: pcmpRequestedSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="PCMP Requested Proposals">
      <Suspense fallback={<PageLoader />}>
        <PcmpRequestedQueuePage />
      </Suspense>
    </ErrorBoundary>
  ),
});
